import { useEffect } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import { MonomerErrorBoundary } from '~/components/MonomerErrorBoundary'
import { MultiFrontendContext } from '~/core/MultiFrontendContext'
import DataIngestorsCreate from './DataIngestorsCreate'
import DataIngestorsList from './DataIngestorsList'
import DataIngestorsPage from './DataIngestorsPage/DataIngestorsPage'
import cs from './data_ingestor_routes.scss'

const DataIngestorRoutes = ({
  frontendContext,
}: {
  frontendContext: MultiFrontendContext
}) => {
  const match = useRouteMatch()

  useEffect(() => {
    if (frontendContext.deploymentMode !== 'on_prem_agent') {
      window.location.href = `${frontendContext.cloudFrontend}`
    }
  }, [frontendContext])
  if (frontendContext.deploymentMode !== 'on_prem_agent') {
    return <div className={cs.routeErrorContainer}>Redirecting...</div>
  }

  return (
    <MonomerErrorBoundary>
      <div className={cs.dataIngestorRoutes}>
        <Switch>
          <Route exact path={match.path} render={() => <DataIngestorsList />} />
          <Route
            exact
            path={`${match.path}/create`}
            render={() => <DataIngestorsCreate />}
          />
          <Route
            exact
            path={`${match.path}/:ingestorUuid`}
            render={({
              match: {
                params: { ingestorUuid },
              },
            }) => <DataIngestorsPage ingestorUuid={ingestorUuid} />}
          />
        </Switch>
      </div>
    </MonomerErrorBoundary>
  )
}

export default DataIngestorRoutes
